import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[cxDisableContextMenu]',
})
export class DisableContextMenuDirective {
  @HostListener('contextmenu', ['$event']) onContextMenu($event: any) {
    $event.preventDefault();
  }
}
